package addedittravelagent

import addedittravelagent.components.TravelAgentBaseInformation
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.unit.dp
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.scroll.EsVerticalScrollbar
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.calf.core.LocalPlatformContext
import core.validation.EsInputState

@Composable
fun AddEditTravelAgentScreen(
    state: AddEditTravelAgentState,
    onEvent: (AddEditTravelAgentEvent) -> Unit,
    onNavigation: (AddEditTravelAgentNavigation) -> Unit = {},
    dialog: Boolean = false,
) {
    val context = LocalPlatformContext.current

    val isEdit by remember(state.travelAgent.value.id) {
        mutableStateOf(
            state.travelAgent.value.id.isNotBlank(),
        )
    }

    var isEditEnabled by remember(state.getTravelAgent.data?.id) { mutableStateOf(false) }

    var firstNameInputState by remember { mutableStateOf(EsInputState.Default) }

    val uriHandler = LocalUriHandler.current

    fun validateFirstName(firstName: String? = state.travelAgent.value.contact?.firstName) =
        if (firstName.isNullOrBlank()) {
            firstNameInputState = EsInputState.Error
            false
        } else {
            firstNameInputState = EsInputState.Default
            true
        }

    fun validate(): Boolean {
        val validationFields =
            listOf(
                validateFirstName(),
            )
        return validationFields.none { !it }
    }

    LaunchedEffect(state.addEditTravelAgent.isSuccess) {
        if (state.addEditTravelAgent.isSuccess) {
            isEditEnabled = false
        }
    }

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier =
            Modifier
                .fillMaxSize(),
    ) {
        Spacer(modifier = Modifier.height(1f.spacing))

        Box(
            modifier =
                Modifier
                    .weight(1f),
        ) {
            val lazyListState = rememberLazyListState()

            LazyColumn(
                verticalArrangement = Arrangement.spacedBy(1f.spacing),
                state = lazyListState,
                modifier =
                    Modifier
                        .fillMaxSize()
                        .clip(
                            RoundedCornerShape(
                                topStart = 24.dp,
                                topEnd = 24.dp,
                            ),
                        ),
            ) {
                if (
                    state.getTravelAgent.isLoading ||
                    state.getTravelAgent.isFailure ||
                    (isEdit && state.getTravelAgent.data == null)
                ) {
                    item {
                        Box(
                            contentAlignment = Alignment.Center,
                            modifier =
                                Modifier
                                    .fillMaxWidth()
                                    .height(200.dp)
                                    .padding(2.5f.spacing)
                                    .clip(RoundedCornerShape(EsConstants.RoundedCornerSize)),
                        ) {
                            if (state.getTravelAgent.isLoading) {
                                EsSpinner()
                            } else {
                                Text(
                                    text = "Something goes wrong!",
                                    color = MaterialTheme.esColorScheme.textSecondary,
                                    style = MaterialTheme.esTypography.p1Medium16,
                                )
                            }
                        }
                    }
                } else {
                    item {
                        TravelAgentBaseInformation(
                            state = state,
                            onEvent = onEvent,
                            onTravelAgentChange = { onEvent(AddEditTravelAgentEvent.UpdateTravelAgentFields(it)) },
                            enabled = if (isEdit) isEditEnabled else true,
                            firstNameInputState = firstNameInputState,
                            validateFirstName = { validateFirstName(it) },
                        )
                    }

                    if (!dialog) {
                        item {
                            val proposals = state.getProposals.data.orEmpty().filter {
                                it.status != ProposalModel.Status.Confirmed
                            }

                            ProposalsAndItinerariesSection(
                                proposals = proposals,
                                itineraries = state.getItineraries.data.orEmpty(),
                                onEditProposalClicked = { onNavigation(AddEditTravelAgentNavigation.EditProposal(it)) },
                                onEditItineraryClicked = { onNavigation(AddEditTravelAgentNavigation.EditItinerary(it)) },
                            )
                        }
                    }
                }
            }

            EsVerticalScrollbar(
                lazyListState = lazyListState,
                modifier =
                    Modifier
                        .align(Alignment.CenterEnd)
                        .fillMaxHeight(),
            )
        }

        Spacer(modifier = Modifier.height(1.dp))

        Box(
            modifier =
                Modifier
                    .background(MaterialTheme.esColorScheme.bgSecondary)
                    .padding(2.5.spacing),
        ) {
            EsLargePrimaryButton(
                onClick = {
                    if (isEdit && !isEditEnabled) {
                        isEditEnabled = true
                    } else if (validate()) {
                        if (isEdit) {
                            onEvent(AddEditTravelAgentEvent.EditTravelAgent(context))
                        } else {
                            onEvent(AddEditTravelAgentEvent.AddTravelAgent(context))
                        }
                    }
                },
                text =
                    if (isEdit) {
                        if (isEditEnabled) {
                            "Save changes"
                        } else {
                            "Edit"
                        }
                    } else {
                        "Add new travel agent"
                    },
                loading = state.addEditTravelAgent.isLoading,
                enabled = if (isEditEnabled) state.isEditEnabled else true,
                modifier =
                    Modifier
                        .fillMaxWidth(),
            )
        }
    }
}
